module.exports = __webpack_public_path__ + "static/media/NCS1.fc905800.jpg";